// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6eee87b8","455":"6068e484"}[chunkId] + ".chunk.js";
};